<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">{{ filters.type ? filters.type + ' Report' : 'Arrival/Departure Report' }}</h3>
        <span>
                    <sidebar-filter-button class="mr-2">
                        <div class="px-2">
                            <v-text-field
                                :elevation="0"
                                class="mb-4"
                                flat
                                hide-details
                                placeholder="Search by name here..."
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.query"
                                @keypress.enter="fetchFiltersData"
                                outlined
                            />
                            <v-text-field
                                class="mb-4"
                                flat
                                hide-details
                                placeholder="Document Number"
                                prepend-inner-icon="filter_list"
                                solo
                                outlined
                                v-model="filters.document_number"
                                @keypress.enter="fetchFiltersData"
                            />
                            <v-text-field
                                :elevation="0"
                                class="mb-4"
                                flat
                                hide-details
                                placeholder="Flight/Bus Number if any"
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.flight_bus_number"
                                @keypress.enter="fetchFiltersData"
                                outlined
                            />
                              <v-autocomplete
                                  outlined
                                  :items="passport_types"
                                  chips
                                  clearable
                                  deletable-chips
                                  flat
                                  hide-details
                                  label="Passport type"
                                  multiple
                                  prepend-inner-icon="filter_list"
                                  solo
                                  v-model="filters.passport_type"
                                  class="mb-4"
                                  @change="fetchFiltersData"
                              />
                             <v-autocomplete
                                 :items="visa_types"
                                 @change="fetchFiltersData"
                                 chips
                                 clearable
                                 deletable-chips
                                 flat
                                 hide-details
                                 item-text="type"
                                 item-value="id"
                                 class="mb-4"
                                 label="Visa Type"
                                 multiple
                                 prepend-inner-icon="filter_list"
                                 solo
                                 v-model="filters.visa_type"
                                 outlined
                             ></v-autocomplete>
                            <div class="mb-4">
                                <custom-date-time-range-picker @change="fetchFiltersData"
                                                               v-model="filters.date_time_range"
                                                               :outlined="true"
                                />
                            </div>


                            <v-autocomplete
                                outlined
                                :items="countries"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="country_name"
                                item-value="id"
                                label="Country"
                                multiple
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.country"
                                class="mb-4"
                                @change="fetchFiltersData"
                            />

                          <v-autocomplete
                              outlined
                              :items="countries"
                              chips
                              clearable
                              deletable-chips
                              flat
                              hide-details
                              item-text="country_name"
                              item-value="id"
                              :label="filters.type ? filters.type  + ' Country' :  'Arrival/Departure Country'"
                              multiple
                              prepend-inner-icon="filter_list"
                              solo
                              v-model="filters.ad_country"
                              class="mb-4"
                              @change="fetchFiltersData"
                          />


                            <v-select
                                :items="ADTypes"
                                flat
                                solo
                                outlined
                                label="Arrival/Departure"
                                v-model="filters.type"
                                clearable
                                hide-details
                                prepend-inner-icon="filter_list"
                                @change="fetchFiltersData"
                                class="mb-4"
                            />

                            <v-select v-if="filters.type === 'Departure'"
                                      :items="purpose_of_departures"
                                      flat
                                      solo
                                      outlined
                                      label="Purpose of departure"
                                      v-model="filters.purpose"
                                      clearable
                                      multiple
                                      hide-details
                                      prepend-inner-icon="filter_list"
                                      @change="fetchFiltersData"
                                      class="mb-4"
                            />

                          <!--                            <v-autocomplete-->
                          <!--                                :items="offices"-->
                          <!--                                flat-->
                          <!--                                hide-details-->
                          <!--                                label="Office"-->
                          <!--                                item-text="name"-->
                          <!--                                item-value="id"-->
                          <!--                                class="mb-4"-->
                          <!--                                prepend-inner-icon="filter_list"-->
                          <!--                                solo-->
                          <!--                                @change="fetchFiltersData"-->
                          <!--                                v-model="filters.office"-->
                          <!--                                clearable-->
                          <!--                                outlined-->
                          <!--                            />-->
                          <v-autocomplete
                              outlined
                              :items="offices"
                              chips
                              clearable
                              deletable-chips
                              flat
                              hide-details
                              item-text="name"
                              item-value="id"
                              label="Offices"
                              multiple
                              prepend-inner-icon="filter_list"
                              solo
                              v-model="filters.offices"
                              class="mb-4"
                              @change="fetchFiltersData"
                          />
                            <officer-select-filter
                                :outlined="true"
                                v-model="filters.officer"
                                @input="fetchFiltersData"
                            />
                              <v-autocomplete
                                  outlined
                                  :items="airlines"
                                  chips
                                  clearable
                                  deletable-chips
                                  flat
                                  hide-details
                                  item-text="airline_name"
                                  item-value="id"
                                  label="Airline"
                                  multiple
                                  prepend-inner-icon="filter_list"
                                  solo
                                  v-model="filters.airlines"
                                  class="mb-4 mt-4"
                                  @change="fetchFiltersData"
                              />
                            <v-autocomplete
                                outlined
                                :items="desks"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="terminal_desk"
                                item-value="terminal_desk"
                                label="Desks"
                                multiple
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.desks"
                                class="mb-4 mt-4"
                                @change="fetchFiltersData"
                            />
                            <v-select
                                :items="genderOptions"
                                flat
                                solo
                                outlined
                                label="Gender"
                                v-model="filters.gender"
                                clearable
                                hide-details
                                prepend-inner-icon="filter_list"
                                @change="fetchFiltersData"
                                class="mb-4"
                            />
                        </div>

                    </sidebar-filter-button>
                <export-excel-button :export-data="exportData"
                                     v-if="$oauth.checkIfHasPermission(['export arrival-departure-report'])"/>
          <refresh-button :click-function="refreshData"></refresh-button>
                   </span>

      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                class="elevation-0"
                v-if="$oauth.checkIfHasPermission(['read arrived-report'])"
                hide-default-footer
            >
              <template v-slot:item.document_number="{ item }">

                <span class="font-weight-bold" style="font-size: 13px;">{{ item.document_number }}</span>
                <br/>
                <span class style="font-size: 12px;">{{ item.document_type }}</span>
              </template>

              <template v-slot:item.officer="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.officer }} </span>
                <br>
                <span style="font-size: 11px;">{{ item.office_name }}</span>
              </template>

              <template v-slot:item.airline="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.airline }} </span>
                <br>
                <span style="font-size: 11px;" v-if="item.flight_no">(Flight/Bus No: <span class=""
                                                                                           style="font-size: 13px;">{{
                    item.flight_no
                  }})</span></span>
                <span v-else>-</span>
              </template>

              <template v-slot:item.country="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item.country_code }}</span>
                  </template>
                  <span>{{ item.country }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.action="{ item }">
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read traveller-history')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/travellers-history/view/'+item.traveller"
                        :to="'/system/travellers-history/view/'+item.traveller"
                        x-small>
                      <v-icon small>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>View Traveller</span>
                </v-tooltip>
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read visa-request')">
                  <template v-slot:activator="{ on }" v-if="item.submission_no">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/visa-requests/view/'+item.submission_no"
                        :to="'/system/visa-requests/view/'+item.submission_no"
                        x-small>
                      <v-icon small>mdi-equal-box</v-icon>
                    </v-btn>
                  </template>
                  <span>View Visa</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                :disable-next="disableNext"
                                :disable-prev="disablePrev"
                                :perPage="pagination.itemsPerPage"
                                @rowChanged="fetchDataWithRow"
                                @getCount="getCount"
                                :total="total"
                                :items-loading="totalItemsLoading"
                                :showing-of="showingOf"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import CustomDateTimeRangePicker from "../../components/CustomDateTimeRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import OfficerSelectFilter from "../../components/filters/OfficerSelectFilter";
import SidebarFilterButton from "../../components/SidebarFilterButton";
import {fetchDynamicValues} from "@/helpers/dynamicValueHelper";
import RefreshButton from "@/components/RefreshButton";

export default {
  name: "ArrivalDepartureReport",
  data() {
    return {
      ADTypes: [
        "Arrival",
        "Departure",
        "Arrival Cancel",
        "Departure Cancel",
      ],
      genderOptions: ["Male", "Female"],
      passport_types: ['Ordinary passport', 'Diplomatic Passport', 'Official/Service Passport', 'Laissez-passer Passport', 'Crew Passport', 'Travel Document'],
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: false
        },
        {
          text: "Document",
          value: "document_number",
          sortable: false
        },
        {
          text: "Full Name",
          value: "full_name",
          sortable: false
        },
        {
          text: "Country",
          value: "country",
          sortable: false
        },
        {
          text: "Airline",
          value: "airline",
          sortable: false
        },
        {
          text: "Type",
          value: "type",
          sortable: false
        },
        {
          text: "Purpose",
          value: "purpose_of_visit",
          sortable: false
        },
        {
          text: "Remarks",
          value: "extra.remarks",
          sortable: false
        },
        {
          text: "Officer",
          value: "officer",
          sortable: false
        },
        {
          text: "Time",
          value: "created_at",
          sortable: false
        },
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: [true]
      },
      purpose_of_departures: []
    };
  },
  components: {
    RefreshButton,
    SidebarFilterButton,
    OfficerSelectFilter, CustomDateTimeRangePicker, IssuedVisaFooter, ExportExcelButton
  },
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      airlines: "ArrivalDepartureReport/airlines",
      countries: "CountryList/all",
      officers: "UserList/all",
      offices: "OfficeList/offices",
      desks: "TerminalDesk/desks",
      visa_types: "VisaTypeList/all",

    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      fetchOfficers: "UserList/getAll",
      fetchAirlines: "ArrivalDepartureReport/fetchAirlines",
      fetchDesks: "TerminalDesk/fetchData"
    }),
    refreshData() {
      this.fetchData();
    },

  },
  created() {
    if (this.$oauth.checkIfHasPermission(['read traveller-history']))
      this.headers.push(
          {
            text: "Action",
            value: "action",
            sortable: false
          })
  },
  mounted() {
    this.stateName = 'ArrivalDepartureReport';
    this.commonState = this.$store.state.ArrivalDepartureReport;
    this.fetchCountries();
    this.fetchDesks();
    this.$store.dispatch('VisaTypeList/fetchAll');

    if (this.$store.state.OfficeList.offices.length === 0) {
      this.$store.dispatch("OfficeList/fetchData");
    }
    let params = this.$route.params;
    if (params.fromRoute) {
      this.filters.type = params.type;
      this.filters.date_time_range = {"start": params.start_date, "end": params.end_date}
    }
    if (this.$store.state.ArrivalDepartureReport.airlines.length === 0) {
      this.fetchAirlines();
    }

    fetchDynamicValues('PurposeOfDeparture').then((res) => {
      this.purpose_of_departures = res;
    })
    const query = this.$route.query;
    if (query.country || query.start) {
      if (query.country) {
        this.filters.country = Array.isArray(query.country)
            ? query.country.map(Number)
            : [Number(query.country)];
      }
    }
    if (query.start_date && query.end_date) {
      this.filters.date_time_range = {
        "start": query.start_date,
        "end": query.end_date,
      };
    }
    if (query.offices) {
      this.filters.offices = Array.isArray(query.offices)
          ? query.offices.map(Number)
          : [Number(query.offices)];
    }
    this.fetchData();
  },
  watch: {
    '$route.params': function (newVal, oldVal) {
      let params = newVal
      console.log(newVal)
      if (params.fromRoute) {
        let editedFilter = {};
        editedFilter.type = params.type;
        editedFilter.date_time_range = {"start": params.start_date, "end": params.end_date}
        this.setFilters(editedFilter)
        this.fetchData()
      }
    }
  }
}
</script>
